import { atom } from 'jotai';
import { TemplateSettings } from 'modules/data/domain/TemplateSettings';

import { SettingTabs } from './WorkflowSettingsPopupContent.types';

export const workflowSettingsPopupDefaultTabState = atom<SettingTabs>(SettingTabs.General);

export const workflowSettingsPopupActiveSettings = atom<TemplateSettings | null>(null);
